import { settings } from '@/config/settings/index'
import Promise from 'promise-polyfill'

// посылаем запрос, получаем ответ
export const fetchDadata = (query: string, count: number, type: string): Promise<IDadataResponse> => {
  const data = JSON.stringify({
    count,
    query,
  })

  return new Promise((resolve, reject) => {
    $.ajax({
      data,
      dataType: 'json',
      error: () => {
        reject()
      },
      headers: {
        'Accept': 'application/json',
        'Authorization': `Token ${settings.dadata.api_key}`,
        'Content-Type': 'application/json',
      },
      success: (response) => {
        resolve(response)
      },
      type: 'POST',
      url: `${settings.dadata.url}/${type}`,
    })
  })
}
